<template>
  <generic-modal :title="$t('order')" ref="generic_modal" :is_wide="true">
    <div class="columns">
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('customer')"
            :placeholder="$t('select customer')"
            url="/customer/catalog"
            name_field="name"
            value_field="customer_id"
            :add_new="true"
            :is_multiple="false"
            @add_new="create_customer"
            @selected="set_customer"
            ref="customer_dropdown"
          />
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("reception date") }}</label>
          <div class="control">
            <input
              class="input"
              type="date"
              v-model="meta.settings.reception_date"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("delivery date") }}</label>
          <div class="control">
            <input
              class="input"
              type="date"
              v-model="meta.settings.delivery_date"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("status") }}</label>
          <div class="select">
            <select v-model="meta.status_code">
              <option value="N">{{ $t("new") }}</option>
              <option value="D">{{ $t("discarded") }}</option>
              <option value="L">{{ $t("delivered") }}</option>
              <option value="F">{{ $t("finished") }}</option>
              <option value="B">{{ $t("buying materials") }}</option>
              <option value="P">{{ $t("in production") }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="title is-5">{{ $t("order") }}</div>
    <div class="container">
      <p class="buttons is-pulled-right">
        <button class="button is-secondary is-rounded" @click="add_embroidery">
          <span class="icon">
            <i class="fa fa-plus"></i>
          </span>
          <span>{{ $t("add") }}</span>
        </button>
      </p>
      <h5 class="title is-4 pt-3">{{ $t("embroidery list") }}</h5>
      <table
        class="table is-bordered is-fullwidth"
        v-if="meta && meta.embroidery_list"
      >
        <thead>
          <tr>
            <th>{{ $t("embroidery") }}</th>
            <th>{{ $t("quantity") }}</th>
            <th>{{ $t("sale price") }}</th>
            <th>{{ $t("options") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(rsrc, ridx) in meta.embroidery_list" :key="ridx">
            <td>
              <generic-dropdown
                :title="$t('embroidery')"
                :placeholder="$t('select embroidery')"
                :show_title="false"
                url="/embroidery/catalog"
                name_field="name"
                value_field="embroidery_id"
                :is_multiple="false"
                @selected="set_embroidery(ridx, $event)"
                ref="embroidery_dropdown"
              />
            </td>
            <td>
              <input
                type="text"
                class="input"
                v-model="meta.embroidery_list[ridx].quantity"
              />
            </td>
            <td>
              <input
                type="text"
                class="input"
                v-model="meta.embroidery_list[ridx].sale_price"
              />
            </td>
            <td>
              <button
                class="button is-secondary has-text-danger is-rounded"
                @click="delete_embroidery(ridx)"
                :data-tooltip="$t('delete')"
              >
                <span class="icon">
                  <i class="fa fa-trash"></i>
                </span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="container">
      <div class="title is-4 mt-2 is-pulled-right has-text-primary">
        <span>{{ $t("total") }}: {{ format_currency(total) }}</span>
      </div>
    </div>

    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
  <create-customer-modal ref="create_customer_modal" />
</template>
<script>
import {
  put,
  get,
  post,
  generate_error_message_text,
  format_date,
  del,
  confirm_deletion_dialog,
  error_message,
  format_currency,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import CreateCustomerModal from "../../../customer/frontend/customers_datatable/customer_modal/Index.vue";

export default {
  name: "OrderModal",
  components: { GenericModal, GenericDropdown, CreateCustomerModal },
  props: {},
  data() {
    return {
      meta: {
        settings: {},
      },
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return (
        !v.meta.customer_id ||
        !v.meta.embroidery_list ||
        v.meta.embroidery_list.length === 0 ||
        v.meta.embroidery_list.find((rsrc) => {
          return (
            !rsrc.embroidery_id ||
            !rsrc.sale_price ||
            !rsrc.quantity ||
            isNaN(rsrc.quantity) ||
            isNaN(rsrc.sale_price)
          );
        })
      );
    },
    total() {
      let v = this;
      let total = 0;
      if (v.meta.embroidery_list) {
        total = v.meta.embroidery_list.reduce((acc, curr) => {
          let quantity = isNaN(curr.quantity) ? 0 : Number(curr.quantity);
          let sale_price = isNaN(curr.sale_price) ? 0 : Number(curr.sale_price);
          return acc + quantity * sale_price;
        }, 0);
      }
      return total;
    },
  },
  methods: {
    format_currency,
    format_date,
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    edit_modal(order) {
      let v = this;
      v.set_initial_state();
      get("/embroidery-order", { uuid: order.uuid })
        .then((res) => {
          v.meta = res;
          if (res.customer_id) {
            v.$refs.customer_dropdown.set_value(res.customer_id);
          }
          v.meta.embroidery_list = res.embroidery_order_items;
        })
        .catch((err) => {
          v.error = generate_error_message_text(err);
        });

      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      let data = { ...v.meta };
      if (data.uuid) {
        post("/embroidery-order", data)
          .then((res) => {
            v.close_modal();
            v.$emit("success");
          })
          .catch((err) => {
            v.error = generate_error_message_text(err);
          });
      } else {
        put("/embroidery-order", data)
          .then((res) => {
            v.close_modal();
            v.$emit("success");
          })
          .catch((err) => {
            v.error = generate_error_message_text(err);
          });
      }
    },
    set_initial_state() {
      let v = this;
      v.provider_uuid = undefined;
      v.meta = {
        settings: {},
        embroidery_list: [
          {
            embroidery_id: "",
            sale_price: "",
            quantity: 1,
          },
        ],
      };
      v.$refs.customer_dropdown.clear();
      v.error = "";
    },
    add_embroidery() {
      let v = this;
      v.meta.embroidery_list = v.meta.embroidery_list || [];
      v.meta.embroidery_list.push({
        embroidery_id: "",
        sale_price: "",
        quantity: 1,
      });
    },
    set_customer(customer) {
      // console.log("set_customer", customer);
      let v = this;
      if (customer) v.meta.customer_id = customer.customer_id;
      // v.meta.customer_name = customer.name;
      // v.meta.customer_email = customer.email;
      // v.meta.customer_phone = customer.phone;
    },
    create_customer() {
      let v = this;
      v.$refs.create_customer_modal.show_modal();
    },
    set_embroidery(ridx, embroidery) {
      // console.log("set_embroidery", ridx, embroidery);
      let v = this;
      if (embroidery) {
        v.meta.embroidery_list[ridx].embroidery_id = embroidery.embroidery_id;
        v.meta.embroidery_list[ridx].sale_price = embroidery.sale_price;
      }
    },
    delete_embroidery(ridx) {
      let v = this;
      let trgt = v.meta.embroidery_list[ridx];
      if (trgt.uuid) {
        confirm_deletion_dialog(
          v.$t("are you sure to delete embroidery from order?"),
          v,
          () => {
            del("/embroidery-order/item", { uuid: trgt.uuid })
              .then(() => {
                v.meta.embroidery_list.splice(ridx, 1);
              })
              .catch((error) => {
                v.error = generate_error_message_text(error);
              });
          }
        );
      } else v.meta.embroidery_list.splice(ridx, 1);
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
